"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Logo = require("./Logo");
Object.keys(_Logo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Logo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Logo[key];
    }
  });
});